<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    tabbarHeight() {
      if (!this.$store.state.layout.showTabbar) {
        return '0px'
      } else {
        return this.$store.state.env.terminal ? '64px' : '150px'
      }
    },
    isLinksMode() {
      if (this.$store.state.auth.userType == '80' && this.$store.state.auth.loggedIn) {
        return true
      }

      return false
    },
    linksAddClass() {
      if(this.isLinksMode)
      {
        return 'links_mode'
      }
      else {
        return ''
      }
    },
  },
  mounted() {},
}
</script>

<template>
  <div :class="$style.wrapper">
    <slot name="search-header"></slot>
    <div id="jaf_container" ref="container" :class="[$style.container]" v-if="!isLinksMode">
      <slot />
    </div>
    <div id="jaf_container" ref="container" :class="[$style.links_container]" v-else>
      <slot />
    </div>
  </div>
</template>

<style lang="scss" module>
.container {
  position: relative;
  margin: 0 auto;
  overflow: auto;
}
.links_container {
  position: relative;
  margin: 0 auto;
  overflow: auto;
}
@media screen and (min-width: 768px) {
  .container {
    min-width: 1022px;
  }
  .links_container {
    min-width: unset;
  }
}
@media screen and (max-width: 767px) {
  .container {
    height: 100%;
    // height: calc(100% - 15vw);
    overflow-x: hidden;
  }
  .links_container {
    height: 100%;
    // height: calc(100% - 15vw);
    overflow-x: hidden;
  }

  .wrapper {
    height: 100%;
  }
}
</style>
